import { Link } from 'react-router-dom';

const trainings = [
  {
    image: 'https://public.readdy.ai/ai/img_res/cdf2b3b9059d0aeffae2228b2f4af8e0.jpg',
    category: 'Platform Mastery',
    title: 'Airbnb & Hosting Platform Training',
    description: 'Master the ins and outs of Airbnb, VRBO, and other hosting platforms. Learn how to create compelling listings, manage bookings, and leverage platform features.',
    duration: '8 hours'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Professional%20photographer%20taking%20interior%20photos%20of%20beautifully%20staged%20Airbnb%20property%20with%20camera%20equipment%2C%20bright%20natural%20lighting%2C%20modern%20home%20interior%2C%20real%20estate%20photography%20setup%2C%20hospitality%20marketing%2C%20clean%20aesthetic%2C%20professional%20photography%20session&width=600&height=400&seq=train-002&orientation=landscape',
    category: 'Visual Marketing',
    title: 'Photography & Listing Optimization',
    description: 'Learn professional photography techniques and how to write descriptions that convert browsers into bookers. Optimize every aspect of your listing.',
    duration: '6 hours'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Business%20analytics%20dashboard%20showing%20revenue%20growth%20charts%20and%20booking%20statistics%20on%20computer%20screen%2C%20data%20visualization%20for%20vacation%20rental%20performance%2C%20modern%20office%20setting%2C%20financial%20success%20metrics%2C%20professional%20business%20intelligence%2C%20clean%20interface%20design&width=600&height=400&seq=train-003&orientation=landscape',
    category: 'Revenue Growth',
    title: 'Revenue Algorithm Training',
    description: 'Understand how platform algorithms work and learn strategies to maximize your visibility, bookings, and revenue through data-driven decisions.',
    duration: '10 hours'
  }
];

export default function TrainingModule() {
  return (
    <section className="py-24 bg-gradient-to-b from-white to-blue-50/30">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-[#1A2332] mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            Master Airbnb Hosting
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive training programs designed to help you become a successful host and maximize your property's earning potential.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {trainings.map((training, index) => (
            <div 
              key={index}
              className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group cursor-pointer"
            >
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={training.image}
                  alt={training.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span className="inline-block px-4 py-2 bg-[#FF6B6B] text-white text-sm font-semibold rounded-full">
                    {training.category}
                  </span>
                </div>
              </div>

              <div className="p-8">
                <h3 className="text-2xl font-bold text-[#1A2332] mb-4">
                  {training.title}
                </h3>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {training.description}
                </p>

                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-500">
                    <i className="ri-time-line mr-1"></i>
                    Duration: {training.duration}
                  </span>
                  
                  <Link 
                    to="/services"
                    className="inline-flex items-center text-[#FF6B6B] font-semibold hover:gap-2 transition-all cursor-pointer whitespace-nowrap"
                  >
                    Enroll Now
                    <i className="ri-arrow-right-line ml-1"></i>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
